import {Component, EventEmitter, Input, Output} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-modal',
  standalone: false,
  templateUrl: './delete-modal.html',
  styleUrl: './delete-modal.css'
})
export class DeleteModal {
  @Input() title: string = "Delete Entity"
  @Input() description: string = "Are you sure you want to delete this item?"
  @Input() confirmLabel: string = "Delete"
  @Input() cancelLabel: string = "Cancel"
  @Input() isError: boolean = false  // If true, only show OK button (no delete action)
  @Output() event = new EventEmitter<Boolean>()

  constructor(private modal: NgbActiveModal) {
  }

  cancel() {
    this.modal.close(false)
  }

  confirm() {
    this.modal.close(true)
  }
}
